import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoreStateService, ScheduleService, SchoolService } from '@app/core/services';
import { filter, map, Observable, switchMap, tap } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  public banners$: Observable<any>;
  public institucional$: Observable<string>;

  constructor(
    private escolaService: SchoolService,
    private coreStateService: CoreStateService,
    private breakpointObserver: BreakpointObserver,
    private activatedRoute: ActivatedRoute,
    private scheduleService: ScheduleService,
  ) {}

  public ngOnInit() {
    this.banners$ = this.breakpointObserver.observe('(max-width: 576px)').pipe(
      map((state) => state.matches),
      switchMap(this.bannerLink),
    );

    this.institucional$ = this.coreStateService.plugin$.pipe(
      map(
        (plugin) => `${plugin.handler.home.videoInstitucional}&loop=1&mute=1&showinfo=0&controls=0&start=0&autoplay=1`,
      ),
    );

    this.activatedRoute.fragment.pipe(filter((fragment) => fragment === 'contacto')).subscribe(() => {
      this.scheduleService.schedulingOnline();
    });
  }

  public handleBannerClick(url: string, event: Event) {
    event.preventDefault();
    if (url === '#contacto') {
      this.scheduleService.schedulingOnline();
    } else if (url) {
      window.open(url, '_blank');
    }
  }

  private bannerLink = (isMobile: boolean): Observable<any> =>
    this.coreStateService.school$.pipe(
      take(1),
      switchMap((res) => this.escolaService.banners(res.id)),
      map((banners) =>
        banners.map((banner: any) => ({ ...banner, image: isMobile ? banner.mobile_image : banner.desktop_image })),
      ),
    );
}
